import { useEffect, useState, type ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'
import { PageSkeleton } from '@components/shell/PageSkeleton'
import { getSessionLocale } from '@services/session'
import { clearI18nNamespaceCache, ensureI18nNamespace } from './ensureNamespace'
import { getI18NInstance, toI18nextLanguage } from './instance'
import { NAMESPACES_ENUM } from './namespaces'

interface I18nProviderProps {
  children: ReactNode
}

export function I18nProvider({ children }: I18nProviderProps) {
  const i18n = getI18NInstance(true)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function init() {
      const locale = toI18nextLanguage(getSessionLocale())
      if (i18n.language !== locale) {
        clearI18nNamespaceCache()
      }
      await i18n.changeLanguage(locale)
      await ensureI18nNamespace(NAMESPACES_ENUM.COMMON, locale)
      if (!cancelled) {
        setReady(true)
      }
    }

    void init()

    return () => {
      cancelled = true
    }
  }, [i18n])

  if (!ready) {
    return <PageSkeleton />
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
